import React, {FC} from "react";
import {useTranslation} from "react-i18next";
import {PageHeader} from "../../../Components/ui";
import {EventAccessPanel} from "./EventAccessPanel";
import {EventBasicsFormPanel} from "./EventBasicsFormPanel";
import {EventEmailTemplatesPanel} from "./EventEmailTemplatesPanel";
import {EventPaymentMethodsPanel} from "./EventPaymentMethodsPanel";
import {EventTaxPanel} from "./EventTaxPanel";
import {useEventConfigScope} from "./useEventConfigScope";

// Event workspace "settings": basics and public copy, access, tax, payment methods and participant emails.
const EventBasicsPage: FC = () => {
    const {t} = useTranslation();
    const scope = useEventConfigScope();

    return (
        <div className="ati-stack">
            <PageHeader level={2} title={t("event-workspace.settings", {defaultValue: "Event basics"})}/>
            <EventBasicsFormPanel scope={scope}/>
            <EventAccessPanel scope={scope}/>
            <EventTaxPanel scope={scope}/>
            <EventPaymentMethodsPanel scope={scope}/>
            <EventEmailTemplatesPanel scope={scope}/>
        </div>
    );
};

export default EventBasicsPage;
